import { constructClaimedVehicleQueryParam } from '@ltvco/refresh-lib/utils';
import { reportGetters, useReportRedirect } from '@ltvco/refresh-lib/v1';
import { useQueryClient } from '@ltvco/refresh-lib/vendors';

export const useRerunReportAndRefresh = () => {
  const { redirectToReportUrl, location } = useReportRedirect();
  const queryClient = useQueryClient();

  return async (meta: any) => {
    const searchMethod = constructClaimedVehicleQueryParam(
      meta?.search_data,
      meta?.search_by as string,
    );

    const response = await reportGetters.vehicle({
      queryParams: new URLSearchParams({
        ...searchMethod,
      }),
    });

    // If already on the report we just need to invalidate the query
    if (
      location.pathname === '/report/vehicle' &&
      location.search === `?permalink=${response.report.permalink}`
    ) {
      queryClient.invalidateQueries(['report']);
      window.location.reload();
      return;
    }

    redirectToReportUrl('vehicle', response?.report?.permalink);
  };
};
